import React from 'react'

interface PackProps extends React.HTMLAttributes<HTMLDivElement> {
  if?: boolean
  tagName?: string
}
export const Pack: React.FC<PackProps> = ({
  if: show = true,
  tagName = 'div',
  children,
  ...rest
}) => {
  if (!show) return null
  return React.createElement(tagName, rest, children)
}
